import { defineComponent, createElementBlock, openBlock, mergeProps } from "vue";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PTableFilterIcon",
    inheritAttrs: false
  },
  __name: "p-table-filter-icon",
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", mergeProps({
        class: ["h-5 w-5 shrink-0 cursor-pointer filter", { active: __props.active }]
      }, _ctx.$attrs), null, 16);
    };
  }
});
const PTableFilterIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-84864117"]]);
export {
  PTableFilterIcon as default
};
